import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, className = "" }) => (
  <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        style={{ width: size, height: size }}
        className={n <= value ? "fill-cyan-400 text-cyan-400" : "text-slate-600"}
      />
    ))}
  </div>
);

export const StarInput = ({ value, onChange }) => (
  <div className="flex items-center gap-1.5" data-testid="star-input">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        data-testid={`star-input-${n}`}
        onClick={() => onChange(n)}
        className="transition-transform hover:scale-125"
        aria-label={`${n} star`}
      >
        <Star
          className={`w-7 h-7 ${
            n <= value ? "fill-cyan-400 text-cyan-400" : "text-slate-600 hover:text-slate-400"
          }`}
        />
      </button>
    ))}
  </div>
);
